import { render, staticRenderFns } from "./FeedbackFilter.vue?vue&type=template&id=cf28a794&scoped=true"
import script from "./FeedbackFilter.vue?vue&type=script&lang=js"
export * from "./FeedbackFilter.vue?vue&type=script&lang=js"
import style0 from "./FeedbackFilter.vue?vue&type=style&index=0&id=cf28a794&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf28a794",
  null
  
)

export default component.exports